// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d56a84e3","884":"9a94d450"}[chunkId] + ".chunk.js";
};